import { isReadErrorRefusal, type ZeroingRefused } from "@/api/client";

const NUMBER = new Intl.NumberFormat("en-GB");

// The refusal in the words the panel shows. Shared by the jobs card and the
// ingestion page, hence its own module: the card file exports components only.
export function refusalNote(refused: ZeroingRefused): string {
  return isReadErrorRefusal(refused)
    ? `Nothing was zeroed: ${NUMBER.format(refused.rowErrors)} of ` +
        `${NUMBER.format(refused.rowsProcessed)} rows read could not be processed (over 1%), ` +
        "so what the file lacks cannot be trusted. Check the file and run it again."
    : `Nothing was zeroed: ${NUMBER.format(refused.wouldZero)} ` +
        `of ${NUMBER.format(refused.inStock)} in-stock prices were missing, over 15%. ` +
        "Check the file and run it again.";
}

